import { observer } from 'mobx-react-lite'
import { ContainerHeader, Typography } from 'shared/ui'
import { GuideButton } from 'pages/settings/pages/urlShortener/ui/UrlShortenerAction/UrlShortenerAction'
import styles from './styles.module.scss'

export const UrlShortenerListHeader = observer(() => {
  return (
    <ContainerHeader
      customTitle={
        <header className={styles.header}>
          <Typography variant='heading-lg' ariaLabel='URL Shortener header'>
            URL Shortener
          </Typography>
          <Typography
            className={styles.headerDescription}
            variant='body-md-regular'
            ariaLabel='URL Shortener description'
          >
            Shorten links using your own custom domain name
          </Typography>
        </header>
      }
      paddingTop={90}
      paddingBottom={59}
      paddingLeft={4}
      paddingRight={4}
      actionsProps={{
        actions: [{ iconButtonComponent: <GuideButton className={styles.guideButton} /> }],
      }}
    />
  )
})
